import meetingRoom from '../../modules/meetingRoom/reducer'

const reducers = {
  meetingRoom,
}

export default reducers
